/* ============================================================
   KITTED — storefront interactions
   - announcement rotor
   - drawers (cart / mobile nav) + scrim, via data-open="true|false"
   - AJAX cart (add / change / remove) with Section Rendering API
   - free-shipping progress (re-rendered server-side in the drawer section)
   - accordions, sticky add-to-cart, collection filter-group collapse, toast
   ============================================================ */
(function () {
  "use strict";

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- drawers / overlay ---------- */
  function setOpen(el, open) { if (el) el.dataset.open = open ? "true" : "false"; }

  function openDrawer(which) {
    setOpen($("#scrim"), true);
    document.body.style.overflow = "hidden";
    if (which === "cart") setOpen($("#cart-drawer"), true);
    if (which === "nav") setOpen($("#mobile-nav"), true);
    if (which === "filters") setOpen($("#filter-drawer"), true);
  }

  function closeAll() {
    setOpen($("#cart-drawer"), false);
    setOpen($("#mobile-nav"), false);
    setOpen($("#filter-drawer"), false);
    setOpen($("#scrim"), false);
    document.body.style.overflow = "";
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $("#toast");
    if (!t) return;
    var label = $("[data-toast-text]", t);
    if (label) label.textContent = msg;
    t.dataset.visible = "true";
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.dataset.visible = "false"; }, 2400);
  }

  /* ---------- cart counts ---------- */
  function setCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.classList.toggle("hidden", n === 0);
    });
  }

  /* ---------- swap the drawer markup from a Section Rendering response ---------- */
  function replaceDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.querySelector("#cart-drawer");
    var current = $("#cart-drawer");
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  /* ---------- cart mutations ---------- */
  function refreshCount(cart) {
    if (cart && typeof cart.item_count === "number") {
      setCount(cart.item_count);
      return Promise.resolve();
    }
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); });
  }

  function addToCart(form) {
    var body = new FormData(form);
    body.append("sections", "cart-drawer");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: body,
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || "Sorry — couldn't add that."); return; }
        if (res.data.sections) replaceDrawer(res.data.sections["cart-drawer"]);
        refreshCount(null).then(function () {
          openDrawer("cart");
          toast("Added — " + (res.data.product_title || res.data.title || "item"));
        });
      })
      .catch(function () { toast("Something went wrong."); });
  }

  function changeLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity, sections: ["cart-drawer"] }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections) replaceDrawer(cart.sections["cart-drawer"]);
        refreshCount(cart);
      })
      .catch(function () { toast("Something went wrong."); });
  }

  /* ---------- collection AJAX filtering ----------
     Filters apply on change (no "Apply" button). On any change we serialize the
     active form (filters or sort — each carries the other's state), fetch the
     collection section via the Section Rendering API, and swap in the freshly
     rendered sidebar (recomputed valid values / counts) + grid + chips. Inputs
     are disabled while in flight; the fresh markup re-enables them. */
  function filterResults() { return $("[data-filter-results]"); }

  function loadFiltered(url, push) {
    var results = filterResults();
    if (!results) return;
    // Keep the mobile filter drawer open across the re-render (it lives inside
    // the swapped markup, so its data-open would otherwise reset to "false").
    var drawer = $("#filter-drawer");
    var drawerOpen = drawer && drawer.dataset.open === "true";
    results.dataset.loading = "true";
    $$("input, select", results).forEach(function (el) { el.disabled = true; });
    var sectionId = results.getAttribute("data-section-id");
    var fetchUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "section_id=" + encodeURIComponent(sectionId);
    fetch(fetchUrl, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-filter-results]");
        if (fresh) results.innerHTML = fresh.innerHTML;
        results.dataset.loading = "false";
        if (drawerOpen) setOpen($("#filter-drawer"), true);
        if (push !== false) history.pushState({ filtered: true }, "", url);
      })
      .catch(function () {
        results.dataset.loading = "false";
        $$("input, select", results).forEach(function (el) { el.disabled = false; });
        toast("Couldn't update filters.");
      });
  }

  function urlFromForm(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== "" && value != null) params.append(key, value);
    });
    var qs = params.toString();
    return window.location.pathname + (qs ? "?" + qs : "");
  }

  document.addEventListener("change", function (e) {
    var form = e.target.closest("form[data-filters-form], form[data-sort-form]");
    if (form && filterResults()) { e.preventDefault(); loadFiltered(urlFromForm(form), true); }
  });

  window.addEventListener("popstate", function () {
    if (filterResults()) loadFiltered(window.location.pathname + window.location.search, false);
  });

  /* ---------- delegated clicks ---------- */
  document.addEventListener("click", function (e) {
    // collection filter links (chip removal / clear-all) — AJAX instead of nav
    var filterLink = e.target.closest("[data-filter-link]");
    if (filterLink && filterResults()) { e.preventDefault(); loadFiltered(filterLink.getAttribute("href"), true); return; }

    var opener = e.target.closest('[data-open="cart"],[data-open="nav"],[data-open="filters"]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute("data-open")); return; }

    if (e.target.closest("[data-close]")) { e.preventDefault(); closeAll(); return; }

    // cart line removal (event-delegated, so survives drawer re-render).
    // One-of-one: qty is always 1, so the only line op is remove.
    var act = e.target.closest("[data-act]");
    if (act) {
      var row = act.closest("[data-key]");
      if (!row) return;
      if (act.getAttribute("data-act") === "rm") changeLine(row.getAttribute("data-key"), 0);
      return;
    }

    // accordion
    var accBtn = e.target.closest("[data-accordion-toggle]");
    if (accBtn) {
      var item = accBtn.closest("[data-accordion]");
      if (item) item.dataset.open = item.dataset.open === "true" ? "false" : "true";
      return;
    }

    // collection filter-group collapse
    var fgBtn = e.target.closest("[data-filter-toggle]");
    if (fgBtn) {
      var group = fgBtn.closest("[data-filter-group]");
      if (group) group.dataset.open = group.dataset.open === "false" ? "true" : "false";
      return;
    }
  });

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });

  /* ---------- intercept add-to-cart forms ---------- */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (form.matches('form[action*="/cart/add"]')) { e.preventDefault(); addToCart(form); }
  });

  /* ---------- announcement rotor ---------- */
  function initRotor() {
    var msgs = $$("[data-rotor-msg]");
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].dataset.active = "false";
      i = (i + 1) % msgs.length;
      msgs[i].dataset.active = "true";
    }, 3800);
  }

  /* ---------- sticky add-to-cart (PDP) ---------- */
  function initStickyAtc() {
    var bar = $("#stickyAtc");
    var anchor = $("#atcAnchor");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      bar.dataset.visible = !en.isIntersecting && en.boundingClientRect.top < 0 ? "true" : "false";
    }, { threshold: 0 }).observe(anchor);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRotor();
    initStickyAtc();
  });
})();
